import styled from 'styled-components'
import {
  compose,
  space,
  color,
  typography,
  SpaceProps,
  ColorProps,
  TypographyProps,
  variant,
} from 'styled-system'
import propTypes from '@styled-system/prop-types'

type TextVariants = 'body' | 'heading'
type VariantProp = {
  variant?: TextVariants
}

export type TextProps = SpaceProps & ColorProps & TypographyProps & VariantProp

const propsToOmit = [
  ...Object.keys(propTypes.space),
  ...Object.keys(propTypes.color),
  ...Object.keys(propTypes.typography),
  'css',
]

const textVariants: TODO = variant({
  variants: {
    body: {
      fontWeight: 'regular',
      fontSize: 1,
      color: 'gray.6',
      textDecoration: 'none',
    },
    heading: {
      fontWeight: 'regular',
      fontSize: { _: 2, tablet: 3 },
      color: 'gray.6',
      textDecoration: 'none',
    },
  },
})

const Text = styled.p.withConfig({
  shouldForwardProp: (prop) => !propsToOmit.includes(prop as string),
})<TextProps>`
  ${textVariants}
  ${compose(space, color, typography)}
`

Text.defaultProps = {
  variant: 'body',
}

export default Text
